import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { Post } from 'redux/reducers/feed'
import { normalizeTimestamp, checkChatHasUnread } from '../utils'

export type ChatWithMetadata = {
  chat: Post
  hasUnread: boolean
  normalizedTimestamp: number
  category: number
  isFaded: boolean
  sortValue: number
}

export const usePersonalViewChatsSorting = (chats: Post[]): ChatWithMetadata[] => {
  const commentsState = useSelector((state: RootState) => state.comments.commentsState)
  const viewedCommentsIds = useSelector((state: RootState) => state.comments.viewedCommentsIds)

  const sortedChats = useMemo(() => {
    if (!chats || chats.length === 0) return []

    const chatsWithMetadata: ChatWithMetadata[] = chats.map((chat) => {
      const hasUnread = checkChatHasUnread(chat, commentsState, viewedCommentsIds)
      const normalizedTimestamp = normalizeTimestamp(chat.updated_at_ts || 0)

      const category = hasUnread ? 5 : 6
      const isFaded = !hasUnread
      // Для обеих категорий используем положительное значение timestamp для сортировки по убыванию (новые первыми)
      const sortValue = normalizedTimestamp

      return {
        chat,
        hasUnread,
        normalizedTimestamp,
        category,
        isFaded,
        sortValue,
      }
    })

    // Sorting: first by category (5 before 6), then by sortValue descending (newest first)
    return chatsWithMetadata.sort((a, b) => {
      if (a.category !== b.category) return a.category - b.category
      // Both categories 5 and 6 sort descending (newest first)
      return b.sortValue - a.sortValue
    })
  }, [chats, commentsState, viewedCommentsIds])

  return sortedChats
}
